export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'driverName',
    align: 'left',
    minWidth: 200,
    title: '司机姓名',
    sortable: true,
    sortType: 'String',
  },
  {
    headerAlign: 'center',
    field: 'driverMobile',
    align: 'center',
    minWidth: 130,
    title: '司机手机号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverID',
    align: 'left',
    minWidth: 200,
    title: '司机身份证号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'v_driverOwnerType',
    align: 'center',
    minWidth: 100,
    title: '司机归属',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    minWidth: 250,
    title: '登记机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverLicenseType',
    align: 'center',
    minWidth: 80,
    title: '驾照类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverLicense',
    align: 'left',
    minWidth: 200,
    title: '驾驶证号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverLicenseValidity',
    align: 'center',
    minWidth: 120,
    title: '驾驶证有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'carrierName',
    align: 'left',
    minWidth: 200,
    title: '所属承运商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'depositBank',
    align: 'left',
    minWidth: 200,
    title: '开户银行',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverRemarks',
    align: 'left',
    minWidth: 300,
    title: '备注',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'String',
  },
  {
    headerAlign: 'center',
    field: 'driverStatusName',
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'String',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'String',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
